import { Link } from 'react-router-dom';
import { BUSINESS } from '../../Legal/legalContent';
import './Footer.scss';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className="Footer-container">
      <div className="footer-top">
        <div>
          <div>Get to Know Us</div>
          <div><Link to="/about">About Us</Link></div>
          <div><Link to="/contact">Contact Us</Link></div>
        </div>

        <div>
          <div>Policies</div>
          <div><Link to="/terms">Terms &amp; Conditions</Link></div>
          <div><Link to="/privacy">Privacy Policy</Link></div>
          <div><Link to="/refund-policy">Cancellation &amp; Refunds</Link></div>
          <div><Link to="/shipping-policy">Shipping Policy</Link></div>
        </div>

        <div>
          <div>Help</div>
          <div><Link to="/contact">Support</Link></div>
          <div><a href={BUSINESS.mailtoHref}>{BUSINESS.email}</a></div>
          <div><a href={BUSINESS.telHref}>{BUSINESS.phone}</a></div>
        </div>
      </div>

      <div className="footer-bottom">
        <div>
          <ul>
            <li><Link to="/terms">Terms of Use</Link></li>
            <li><Link to="/privacy">Privacy Notice</Link></li>
            <li><Link to="/refund-policy">Refunds</Link></li>
          </ul>
          <span>© {year} {BUSINESS.brandName} · Operated by {BUSINESS.legalName}</span>
        </div>
      </div>
    </div>
  );
}
